<script>
    import { getParams } from './utils.js';

    function formatDate(dateString) {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options);
    }

    const params = getParams();

    let keyword = params.keyword;
    let date = formatDate(params.date);
</script>

<div class="border-zinc-700 border-2 rounded-r-xl mb-2 ml-2">
    <h1 class="text-white font-bold text-2xl p-3 uppercase">{keyword}</h1>
    <hr class="border-zinc-700 ml-2 mr-2">
    <h1 class="text-white font-bold text-lg p-3">{date}</h1>
</div>